var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.85 0C23.0514 0 29.7 6.64857 29.7 14.85C29.7 18.4609 28.4112 21.7708 26.2686 24.3447L37.8 35.8784L35.8908 37.7876L24.3584 26.2571C21.7825 28.4066 18.4673 29.7 14.85 29.7C6.64857 29.7 0 23.0514 0 14.85C0 6.64857 6.64857 0 14.85 0ZM14.85 2.7C8.13974 2.7 2.7 8.13974 2.7 14.85C2.7 21.5603 8.13974 27 14.85 27C21.5603 27 27 21.5603 27 14.85C27 8.13974 21.5603 2.7 14.85 2.7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5128 8.1101L9.60701 8.19328L14.8999 13.4854L20.1928 8.19328L20.287 8.1101C20.6793 7.80507 21.2465 7.8328 21.607 8.19328C21.9675 8.55377 21.9952 9.121 21.6902 9.51329L21.607 9.6075L16.3149 14.9004L21.607 20.1933C21.9975 20.5838 21.9975 21.217 21.607 21.6075C21.2465 21.968 20.6793 21.9957 20.287 21.6907L20.1928 21.6075L14.8999 16.3154L9.60701 21.6075L9.5128 21.6907C9.12051 21.9957 8.55328 21.968 8.1928 21.6075C7.83231 21.247 7.80458 20.6798 8.10961 20.2875L8.1928 20.1933L13.4849 14.9004L8.1928 9.6075C7.80227 9.21697 7.80227 8.58381 8.1928 8.19328C8.55328 7.8328 9.12051 7.80507 9.5128 8.1101Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.318b1f24.svg";
export { ForwardRef as ReactComponent };